import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

function Loading({ label }) {
  return (
    <div className="loadingWrapper">
      <Spin indicator={antIcon} />
      <p>{label}</p>
    </div>
  );
}

export default Loading;
